import store from '../../store/store';
import detectCardType from '../../validation/detectCardType';
import luhnChecker from './luhnChecker';
import maxLength from './max-length';
import minLength from './minLength';
import rangeLength from './range-length';

const invalidCardNumberErrorKey = 'errors.formFields.creditCardNumber';
const cardFixedLengthErrorKey = 'errors.formFields.fixedLength.creditCardNumber';

const validateCardNumberWithSettings = (value) => {
  // TO-DO - to be removed when all card number field is reacted as new field disables all non digit input
  if (/[^0-9 \-]+/.test(value)) return invalidCardNumberErrorKey;
  const replacedValue = value.replace(/\D/g, '');
  
  if (replacedValue.length < 6) return invalidCardNumberErrorKey;
  
  const card = detectCardType(replacedValue);
  
  if (card.fixedLength) {
    const fixedLengths = card.fixedLength;
    // check for match
    const validLength = fixedLengths.some(length => replacedValue.length === length);
    
    if (!validLength) {
      if (fixedLengths.length === 1) return minLength(fixedLengths[0], 'creditCardNumber')(replacedValue) || maxLength(fixedLengths[0], 'creditCardNumber')(replacedValue);
      return [cardFixedLengthErrorKey, fixedLengths[0], fixedLengths[1]];
    }
  }
  if (card.minLength && card.maxLength) return rangeLength(card.minLength, card.maxLength, 'creditCardNumber')(replacedValue);
  if (card.name === 'non-supported-card' && replacedValue.length < 12) return invalidCardNumberErrorKey;
  
  if (!luhnChecker(replacedValue)) return invalidCardNumberErrorKey;
};

const validateCardNumber = (value) => {
  // accept only spaces, digits and dashes
  if (/[^0-9 \-]+/.test(value)) return invalidCardNumberErrorKey;
  
  // Remove non-digits
  const replacedValue = value.replace(/\D/g, '');
  
  if (replacedValue.length < 11
    || replacedValue.length > 19
    || !luhnChecker(replacedValue)) return invalidCardNumberErrorKey;
};

const cardNumberValidator = () => (cardNumber) => {
  if (store.getState().start.settings.card_number_length_payment_validation_enabled) return validateCardNumberWithSettings(cardNumber);
  return validateCardNumber(cardNumber);
};

export default cardNumberValidator;
